// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"86ae7270","703":"854e7843"}[chunkId] + ".chunk.js";
};